/* eslint-disable valid-jsdoc */
import { type IStructuredLogBase } from '../types/structured-log-types';

export const structuredLogEventName = 'structured-log';

/**
 * `createStructuredLogEvent` creates a custom event with the structured log data
 * @param structuredLog - structured log data
 * @returns custom event with the structured log data
 */
const createStructuredLogEvent = <T extends IStructuredLogBase>(
  structuredLog: T
) => (
    new CustomEvent<typeof structuredLog>(
      structuredLogEventName,
      {
        detail: structuredLog,
      }
    )
  );

/**
 * `dispatchStructuredLogEvent` dispatches a custom event with the structured log data
 * @param structuredLog - structured log data
 */
export const dispatchStructuredLogEvent = <T extends IStructuredLogBase>(
  structuredLog: T
) => {
  if (!structuredLog) return;

  const cutomEvent = createStructuredLogEvent(structuredLog);
  window.dispatchEvent(cutomEvent);
};
